module.exports = __webpack_public_path__ + "static/media/theZoneBizSampleFile.3d7e5814.xlsx";